import { Link } from "react-router-dom";
import { logo } from "../../assets/images";
import useLogic from "./Logic";
import { useState } from "react";
import Waitlist from "./Waitlist";
import Modal from "../modal";

const NavBar = () => {
  const variables = useLogic();
  const [modalOpen, setModalOpen] = useState(false);
  const close = () => setModalOpen(false);
  const open = () => setModalOpen(true);
  const waitlist = () => {
    modalOpen ? close() : open();
  };
  return (
    <div>
      <div className="flex justify-between flex-row items-center py-2 ">
        <div>
          <Link to="/">
            <img src={logo} className="h-[55px] md:h-[65px]" alt="Logo" />
          </Link>
        </div>

        <div>
          <div className="flex flex-row  items-center">
            <div className="hidden">
              <ul className="flex space-x-6 justify-center text-center items-center">
                {variables.navItems.map((item) => (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className={` hover:text-gray-800 text-[15px] font-semibold text-gray-500`}
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div
              onClick={waitlist}
              className="flex justify-center hover:cursor-pointer items-center rounded-xl bg-[#0A0A0A] px-5 py-3"
            >
              <h1 className="text-[14px] text-white font-semibold">
                Join waitlist
              </h1>
            </div>
          </div>
        </div>
      </div>

      {modalOpen && (
        <Modal open={modalOpen} setOpen={setModalOpen} text={<Waitlist />} />
      )}
    </div>
  );
};

export default NavBar;
